import Vue from 'vue';
import 'blocks/sectionTestimonial';
import 'pages/contact/contactMap';
import { initReadingAid } from 'tools/readingAid';
import { DomReady } from 'tools/domready';
import xmoHighlightsSection from 'outlook/components/marketHighlights/highlightSectionsAll';
import { marketHighlightsStore } from 'outlook/store/marketHighlightsStore';

const MAX_VISIBLE_CHILDREN = 6;

const heightFunction = readingAidContainer => {
    const header = readingAidContainer.querySelector('[data-market-directory-header]');
    let children = readingAidContainer.querySelectorAll('[data-market-directory-child]');
    children = Array.prototype.slice.call(children).slice(0, MAX_VISIBLE_CHILDREN);
    const headerHeight = header ? header.offsetHeight : 0;
    let childrenHeight = 0;
    children.forEach(child => {
        childrenHeight = childrenHeight + child.offsetHeight;
    });

    return headerHeight + childrenHeight;
};

const xmoSectionsElement = document.querySelector('[data-vue-xmo-sections]');
if (xmoSectionsElement) {
    new Vue({
        el: xmoSectionsElement,
        store: marketHighlightsStore,
        render(createElement) {
            return createElement(xmoHighlightsSection);
        },
    });
}

DomReady(() => {
    initReadingAid(heightFunction);
});
